<template>
  <BCard>
    <div class="text-[#333333] text-[20px] font-semibold">
      Top Up Whitelisted
    </div>
    <div class="flex justify-end items-center overflow-x-auto">
      <div class="flex items-center gap-4">
        <div
          class="flex items-center !w-[300px] rounded-[8px] gap-[5px] px-[8px] border-[1px] border-[#E2E2E2] h-[40px]"
        >
          <span
            class="k-search-normal-1 font-bold align-middle"
            style="font-size: 20px"
          />
          <BFormInput
            v-model="search"
            placeholder="Cari nama, email, transaksi"
            class="border-0 grow"
            @input="searchData"
          />
        </div>
        <BButton
          id="filter"
          size="sm"
          variant="primary"
          class="position-relative"
          @click="set => (dropdownFilter = !dropdownFilter)"
        >
          <img
            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/filter-search.svg"
            alt="Komerce"
            width="20"
          >
          <span
            v-if="activeFilterCount > 0"
            class="bg-[#F95031] -top-4 badge position-absolute start-100 translate-middle rounded-pill"
          >
            <span class="text-white font-semibold">{{
              activeFilterCount
            }}</span>
          </span>
        </BButton>
        <ul
          v-if="dropdownFilter"
          class="d-block position-absolute bg-[#f9f9f9] right-[10px] top-[100px] z-10 text-black font-medium text-[12px] pb-1 rounded-xl"
        >
          <div class="text-black pl-2 py-1 text-[16px] border rounded-t-xl">
            Filter
          </div>
          <div class="hover:bg-[#FCD4BE]">
            <date-range-picker
              ref="picker"
              v-model="dateRange"
              :locale-data="locale"
              :ranges="ranges"
              :opens="'left'"
              class="w-100"
              control-container-class="border-0"
            >
              <template v-slot:input>
                <div class="d-flex btn">
                  <span>Tanggal</span>
                  <div
                    v-if="dateRange.startDate && dateRange.endDate"
                    class="text-primary ml-[5px]"
                  >
                    (1)
                  </div>
                </div>
              </template>
            </date-range-picker>
          </div>
          <div class="hover:bg-[#FCD4BE]">
            <div
              id="popoverStatusFilter"
              class="btn d-flex w-100"
              role="button"
              tabindex="0"
            >
              <span>Status</span>
              <div
                v-if="statusFilter !== null"
                class="text-primary ml-[5px]"
              >
                (1)
              </div>
            </div>
            <b-popover
              target="popoverStatusFilter"
              triggers="click"
              placement="left"
            >
              <div
                v-for="(item, index) in statusOptions"
                :key="index"
              >
                <b-form-radio
                  v-model="statusFilter"
                  :value="item.value"
                  class="custom-control-primary mb-1"
                  name="status-radio"
                >
                  <span class="text-black">
                    {{ item.text }}
                  </span>
                </b-form-radio>
              </div>
            </b-popover>
          </div>
          <div class="hover:bg-[#FCD4BE]">
            <div
              id="popoverPlatformFilter"
              class="btn d-flex w-100"
              role="button"
              tabindex="0"
            >
              <span>Platform</span>
              <div
                v-if="platformFilter !== null"
                class="text-primary ml-[5px]"
              >
                (1)
              </div>
            </div>
            <b-popover
              target="popoverPlatformFilter"
              triggers="click"
              placement="left"
            >
              <div
                v-for="(item, index) in platformOptions"
                :key="index"
              >
                <b-form-radio
                  v-model="platformFilter"
                  :value="item.value"
                  class="custom-control-primary mb-1"
                  name="platform-radio"
                >
                  <div class="flex flex-row gap-[4px]">
                    <img
                      v-if="item.icon"
                      :src="item.icon"
                      alt="icon"
                      width="16"
                      height="16"
                    >
                    <span class="text-black">
                      {{ item.text }}
                    </span>
                  </div>
                </b-form-radio>
              </div>
            </b-popover>
          </div>
          <div class="border-t-2 pt-1 justify-between d-flex gap-4 px-1">
            <b-button
              variant="outline-primary"
              class="w-40 rounded-lg"
              @click="resetFilter"
            >
              Reset Filter
            </b-button>
            <b-button
              type="submit"
              variant="primary"
              class="w-40 rounded-lg"
              @click="applyTableFilter"
            >
              Terapkan
            </b-button>
          </div>
        </ul>
        <BButton
          id="download"
          size="sm"
          variant="outline-primary"
          class="position-relative !flex !flex-row !items-center"
          :disabled="loading.download"
          @click="downloadExcel"
        >
          <img
            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/import-2.svg"
            alt="download"
            class="mr-[4px]"
            width="20"
            height="20"
          >
          Download
        </BButton>
      </div>
    </div>
    <div class="mt-[16px]">
      <BOverlay
        :show="loading.table"
        spinner-variant="primary"
        variant="light"
        blur="0"
        opacity=".5"
        rounded="sm"
      >
        <div
          id="table"
          class="mt-1"
          :class="items.length > 20 && 'scrolled-table'"
          @scroll="handleScroll"
        >
          <BTable
            :items="items"
            :fields="fields"
            show-empty
            empty-text="Tidak ada data yang ditampilkan"
            responsive
            class="rounded-lg border border-solid"
          >
            <template #cell(date)="data">
              <div class="flex flex-col">
                <span>
                  {{
                    `${TIME(data.item.updated_at)}, ${DAY_MONTH_YEAR(
                      data.item.updated_at
                    )}`
                  }}
                </span>
                <span class="text-[#828282] text-sm">
                  {{ data.item.transaction_id }}
                </span>
              </div>
            </template>
            <template #cell(target_account)="data">
              <div class="flex flex-col">
                <span class="text-[#333333]">{{
                  data.item.whitelist_account_name
                }}</span>
                <span class="text-[#828282] text-sm">{{
                  data.item.partner_email
                }}</span>
              </div>
            </template>
            <template #cell(nominal)="data">
              {{ IDR(data.item.amount_topup) }}
            </template>
            <template #cell(platform_name)="data">
              <div class="flex items-center justify-center">
                <img
                  :src="platformIcon(data.item.platform_name)"
                  alt="icon"
                  width="30"
                  height="30"
                >
                <img
                  v-if="!!data.item.ad_account_type && data.item.ad_account_type === 'cpas'"
                  src="https://storage.googleapis.com/komerce/komads-meta/shopee.svg"
                  alt="icon"
                  width="30"
                  height="30"
                >
              </div>
            </template>
            <template #cell(status)="data">
              <span
                :class="[
                  'px-1 py-[.5rem] rounded-lg w-full inline-block contents-center text-center capitalize',
                  data.item.status === 'success' ? 'bg-[#E6F6EB] text-[#30A46C]' : '',
                  data.item.status === 'process' ? 'bg-[#FFD0B5] text-[#E55514]' : '',
                  data.item.status === 'processing' ? 'bg-[#F0F0F0] text-[#8D8D8D]' : '',
                  data.item.status === 'transferred' ? 'bg-[#E6F4FE] text-[#0090FF]' : '',
                  data.item.status === 'failed' ? 'bg-[#FEEBEC] text-[#DC2626]' : '',
                ]"
              >
                {{ transactionDetailStatus[data.item.status] }}
              </span>
            </template>
            <template #cell(action)="data">
              <BButton
                variant="light"
                class="rounded-lg !p-[4px_8px] flex items-center justify-center"
                @click.prevent="handleDetailDrawer(data.item.id)"
              >
                <i class="k-receipt-text !text-2xl !text-[#828282]" />
              </BButton>
            </template>
          </BTable>
        </div>
      </BOverlay>
    </div>

    <!-- Modal Konfirmasi -->
    <BModal
      id="modal-confirm"
      hide-header
      hide-footer
      centered
      content-class="rounded-lg"
    >
      <div
        class="position-absolute"
        style="right: 15px; top: 15px;"
      >
        <feather-icon
          icon="XIcon"
          class="cursor-pointer w-[20px] h-[20px]"
          @click="$bvModal.hide('modal-confirm')"
        />
      </div>
      <div class="text-center mb-2">
        <img
          src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
          alt="Konfirmasi"
          class="mx-auto my-2"
          width="80px"
        >
        <h1 class="font-semibold text-[18px] text-[#333333] mb-2">
          {{ confirmModal.title }}
        </h1>
        <div v-html="confirmModal.message" />
      </div>
      <div class="flex flex-row gap-6 mb-1">
        <BButton
          variant="outline-primary"
          class="flex-1"
          @click="$bvModal.hide('modal-confirm')"
        >
          Batalkan
        </BButton>
        <BButton
          variant="primary"
          class="flex-1"
          :disabled="confirmModal.isLoading"
          @click="confirmModal.affirmativeButtonHandler"
        >
          <b-spinner
            v-if="confirmModal.isLoading"
            small
          />
          <span class="ms-[.5rem]">{{ confirmModal.affirmativeButton }}</span>
        </BButton>
      </div>
    </BModal>

    <ModalSuccessTopup
      id="modal-success-topup"
      :transaction="transactionDetail || {}"
    />

    <DrawerTransactionDetail
      id="detail-drawer"
      :visible="showDetailDrawer"
      :loading="loading.drawer"
      :platform-icon="transactionDetail ? platformIcon(transactionDetail.platform_name) : '#'"
      :transaction="transactionDetail || {}"
      :transaction-status="transactionDetailStatus"
      :transaction-action="transactionDetailAction"
      @on-close="handleCloseDetailDrawer"
      @on-manual-process="() => showConfirmModal(transactionDetail.id, transactionDetail.platform_name === 'meta' ? 'failed-retopup-meta' : 'failed-retopup')"
    />

    <ModalUniqueNumber
      id="modal-unique-number"
      @on-confirm="({ uniqueNumber }) => {
        $bvModal.hide('modal-unique-number')
        handleProcessTopup({ uniqueNumber })
      }"
    />

    <Invoice
      ref="downloadInvoice"
      :data="invoiceData"
      :platform="transactionDetail ? transactionDetail.platform_name : ''"
    />
  </BCard>
</template>

<script>
import {
  DAY_MONTH_YEAR, TIME, YEAR_MONTH_DAY, FULL_DATE_TIME_WITH_WIB,
} from '@/libs/filterDate'
import { newAxiosIns } from '@/libs/axios'
import { IDR } from '@/libs/currency'
import { downloadFileFromBlob } from '@/libs/downloadFile'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import columnConfig from './config'
import ModalSuccessTopup from './ModalSuccessTopup.vue'
import ModalUniqueNumber from './ModalUniqueNumber.vue'
import DrawerTransactionDetail from './DrawerTransactionDetail.vue'
import Invoice from './templates/Invoice.vue'

export default {
  components: {
    ModalSuccessTopup,
    DateRangePicker,
    DrawerTransactionDetail,
    ModalUniqueNumber,
    Invoice,
  },
  data() {
    const today = new Date()
    const yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1)

    const last7 = new Date()
    last7.setDate(last7.getDate() - 6)

    const firstDateOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)

    return {
      TIME,
      DAY_MONTH_YEAR,
      YEAR_MONTH_DAY,
      FULL_DATE_TIME_WITH_WIB,
      IDR,
      fields: columnConfig,
      loading: {
        table: false,
        download: false,
        downloadInvoice: false,
        drawer: false,
        drawerProcess: false,
        drawerProviderAction: false,
      },
      lastData: false,
      limit: 25,
      offset: 0,
      items: [],
      search: null,
      selectedTopupId: null,
      statusFilter: null,
      statusOptions: [
        { value: null, text: 'Semua' },
        { value: 'process', text: 'Belum diproses' },
        { value: 'processing', text: 'Diproses' },
        { value: 'transferred', text: 'Berhasil Transfer' },
        { value: 'failed', text: 'Gagal Top Up' },
        { value: 'success', text: 'Selesai' },
      ],
      platformFilter: null,
      platformOptions: [
        { value: null, text: 'Semua' },
        { value: 'meta', text: 'Meta', icon: 'https://storage.googleapis.com/komerce/komads-meta/meta.svg' },
        { value: 'google', text: 'Google', icon: 'https://storage.googleapis.com/komerce/komads-meta/google.svg' },
        { value: 'tiktok', text: 'Tiktok', icon: 'https://storage.googleapis.com/komerce/komads-meta/tiktok.svg' },
      ],
      transactionDetail: null,
      showDetailDrawer: false,
      transactionDetailActions: {
        process: {
          confirmAction: () => {},
          confirmLabel: 'Proses Top Up',
          providerAction: this.handleCopyTransactionDetailProvider,
          providerLabel: 'Salin Detail Transaksi',
          providerIcon: 'k-copy',
        },
        processing: {
          confirmAction: () => {},
          confirmLabel: 'Proses Top Up',
          providerAction: this.handleCheckStatus,
          providerLabel: 'Cek Status',
        },
        failed: {
          confirmAction: () => this.showConfirmModal(this.transactionDetail.id, 'retopup'),
          confirmLabel: 'Top Up Ulang',
          providerAction: this.handleCopyTransactionDetailProvider,
          providerLabel: 'Salin Detail Transaksi',
          providerIcon: 'k-copy',
        },
        transferred: {
          confirmAction: () => this.showConfirmModal(this.transactionDetail.id, 'success'),
          confirmLabel: 'Selesaikan Transaksi',
          providerAction: this.handleDownloadInvoice,
          providerLabel: 'Download Invoice',
          providerIcon: 'k-bill',
        },
        success: {
          confirmAction: () => {},
          confirmLabel: 'Proses Top Up',
          providerAction: this.handleDownloadInvoice,
          providerLabel: 'Download Invoice',
          providerIcon: 'k-bill',
        },
      },
      transactionDetailStatus: {
        process: 'Belum Diproses',
        processing: 'Diproses',
        transferred: 'Berhasil Transfer',
        failed: 'Gagal Top Up',
        success: 'Selesai',
      },
      providerFeeTopup: {
        google: 3,
        tiktok: 2.5,
        meta: null,
      },
      invoiceData: {},
      dropdownFilter: false,
      today,
      yesterday,
      last7,
      firstDateOfMonth,
      dateRange: {
        startDate: undefined,
        endDate: undefined,
      },
      locale: {
        format: 'dd/mm/yyyy',
        applyLabel: 'Terapkan',
        cancelLabel: 'Batal',
        customRangeLabel: 'Custom Range',
      },
      ranges: {
        'Hari ini': [today, today],
        Kemarin: [yesterday, yesterday],
        '7 Hari Terakhir': [last7, today],
        'Bulan ini': [firstDateOfMonth, today],
      },
      confirmModalAction: '',
      confirmModalType: {
        retopup: {
          title: 'Apakah Kamu yakin ingin memproses ulang transaksi ini?',
          message:
            '<p>Sistem akan kembali memproses transaksi, status akan berubah menjadi <strong>Selesai</strong> dan tidak dapat diubah</p>',
          affirmativeButton: 'Ya, Top Up Sekarang',
          affirmativeButtonHandler: this.reTopup,
          isLoading: false,
        },
        'failed-retopup': {
          title: 'Apakah Kamu sudah proses transfer manual via Finance?',
          message:
            '<p>Sistem akan menyelesaikan proses transaksi, dan status akan berubah menjadi <strong>Berhasil Transfer</strong></p>',
          affirmativeButton: 'Ya, Selesaikan',
          affirmativeButtonHandler: () => this.updateStatus('transferred'),
          isLoading: false,
        },
        'failed-retopup-meta': {
          title: 'Apakah Kamu sudah proses top up manual di Ads Manager?',
          message:
            '<p>Sistem akan menyelesaikan proses transaksi, dan status akan berubah menjadi <strong>Selesai</strong></p>',
          affirmativeButton: 'Ya, Selesaikan',
          affirmativeButtonHandler: () => this.updateStatus('success'),
          isLoading: false,
        },
        success: {
          title: 'Pastikan top up telah berhasil. Lanjutkan pembaruan status transaksi?',
          message:
            '<p>Sistem akan menyelesaikan proses transaksi, dan status akan berubah menjadi <strong>Selesai</strong></p>',
          affirmativeButton: 'Ya, Selesaikan',
          affirmativeButtonHandler: () => this.updateStatus('success'),
          isLoading: false,
        },
        'tiktok-process': {
          title: 'Apakah Kamu yakin ingin memproses transaksi ini?',
          message:
            '<p>Setelah konfirmasi, status akan berubah menjadi <strong>Diproses</strong>. Mohon tunggu beberapa saat hingga status diperbarui menjadi <strong>Berhasil Transfer</strong> atau <strong>Gagal Top Up</strong></p>',
          affirmativeButton: 'Ya, Proses Top Up',
          affirmativeButtonHandler: async () => {
            this.$bvModal.hide('modal-confirm')
            await this.handleProcessTopup()
          },
          isLoading: false,
        },
      },
    }
  },
  computed: {
    activeFilterCount() {
      let count = 0
      if (this.statusFilter !== null) count += 1
      if (this.platformFilter !== null) count += 1
      if (this.dateRange.startDate && this.dateRange.endDate) count += 1
      return count
    },
    /**
     * Get confirmation modal content based on action
    */
    confirmModal() {
      return this.confirmModalType[this.confirmModalAction] || {
        title: '', message: '', affirmativeButton: '', affirmativeButtonHandler: () => {},
      }
    },
    transactionDetailAction() {
      const transactionDetailAction = { ...this.transactionDetailActions[this.transactionDetail?.status] }
      switch (this.transactionDetail?.platform_name) {
        case 'tiktok':
          if (this.transactionDetail?.status === 'process') {
            transactionDetailAction.confirmAction = () => this.showConfirmModal(this.transactionDetail?.id, 'tiktok-process')
          }
          break
        case 'google':
          if (this.transactionDetail?.status === 'process') {
            transactionDetailAction.confirmAction = this.handleConfirmInputNumber
          }
          break
        case 'meta':
          if (this.transactionDetail?.status === 'success') {
            transactionDetailAction.providerAction = this.handleCopyTransactionDetailProvider
            transactionDetailAction.providerLabel = 'Salin Detail Transaksi'
            transactionDetailAction.providerIcon = 'k-copy'
          }
          break
        default:
          break
      }
      return transactionDetailAction
    },
    transactionDetailDisbursementProvider() {
      return this.transactionDetail?.disbursement_provider || {}
    },
  },

  mounted() {
    // Fetch pending count on initial load
    this.$store.dispatch('komadsWhitelist/fetchPendingCount')
    this.getTopupData()
    this.$nextTick(() => {
      const tableEl = document.getElementById('table')
      if (tableEl) {
        tableEl.addEventListener('scroll', this.handleScroll, { passive: true })
        tableEl.addEventListener('touchmove', () => {}, { passive: true })
      }
    })
  },
  beforeDestroy() {
    const tableEl = document.getElementById('table')
    if (tableEl) {
      tableEl.removeEventListener('scroll', this.handleScroll)
      tableEl.removeEventListener('touchmove', () => {})
    }
  },
  methods: {
    /**
     * Apply filter
    */
    async applyTableFilter() {
      await this.fetchData()
      const table = document.getElementById('table')
      table.scrollTop = 0
    },
    /**
     * Check if a status is failed
     */
    isStatusFailed(status) {
      return status === 'failed'
    },
    /**
     * Get topup data from API
     */
    async getTopupData() {
      this.loading.table = true

      const params = {
        limit: this.limit,
        offset: this.offset,
        keyword: this.search,
        status: this.statusFilter,
        platform_name: this.platformFilter,
        start_date: this.dateRange.startDate
          ? YEAR_MONTH_DAY(this.dateRange.startDate)
          : null,
        end_date: this.dateRange.endDate
          ? YEAR_MONTH_DAY(this.dateRange.endDate)
          : null,
      }

      await newAxiosIns
        .get('komads/api/v1/admin/whitelist_accounts/transactions', { params })
        .then(res => {
          const { data } = res.data
          this.items = data
          this.offset += data.length
          if (data.length < this.limit) {
            this.lastData = true
          } else {
            this.lastData = false
          }
        })
        .catch(() => {
          this.items = []
        })
        .finally(() => {
          this.loading.table = false
        })
    },

    /**
     * Handle infinite scroll
     */
    handleScroll(event) {
      const table = event.target || document.getElementById('table')
      if (
        table.scrollTop >= table.scrollHeight - table.offsetHeight - 20
        && !this.loading.table
        && !this.lastData
      ) {
        this.getNextData()
      }
      if (table.scrollTop === 0) {
        setTimeout(() => {
          table.scrollTop = 1
          setTimeout(() => {
            table.scrollTop = 0
          }, 10)
        }, 10)
      }
    },

    /**
     * Get next page of data
     */
    getNextData() {
      if (!this.lastData) {
        this.loading.table = true
        const params = {
          limit: this.limit,
          offset: this.offset,
          keyword: this.search,
          status: this.statusFilter,
          platform_name: this.platformFilter,
          start_date: this.dateRange.startDate
            ? YEAR_MONTH_DAY(this.dateRange.startDate)
            : null,
          end_date: this.dateRange.endDate
            ? YEAR_MONTH_DAY(this.dateRange.endDate)
            : null,
        }

        newAxiosIns
          .get('komads/api/v1/admin/whitelist_accounts/transactions', {
            params,
          })
          .then(res => {
            const { data } = res.data
            this.items.push(...data)
            this.offset += data.length
            if (data.length < this.limit) {
              this.lastData = true
            }
          })
          .finally(() => {
            this.loading.table = false
          })
      }
    },

    /**
     * Handle search with debounce
     */
    searchData: _.debounce(function search() {
      this.offset = 0
      this.lastData = false
      this.dateRange = {
        startDate: undefined,
        endDate: undefined,
      }
      this.statusFilter = null
      this.platformFilter = null
      this.getTopupData()
    }, 1000),

    resetFilter() {
      this.dateRange = {
        startDate: undefined,
        endDate: undefined,
      }
      this.search = null
      this.statusFilter = null
      this.platformFilter = null
      this.fetchData()
    },

    async fetchData() {
      this.offset = 0
      this.lastData = false
      await this.getTopupData()
      this.dropdownFilter = false
    },

    /**
     * Show confirmation modal
     */
    showConfirmModal(id, action) {
      if (!action) return

      this.confirmModalAction = action
      if (this.confirmModalAction === 'retopup' && this.transactionDetail?.platform_name !== 'meta') {
        this.confirmModalType[this.confirmModalAction].affirmativeButtonHandler = () => {
          const { unique_code: uniqueCode } = this.transactionDetailDisbursementProvider
          const data = {}
          if (uniqueCode) data.uniqueNumber = uniqueCode
          this.handleProcessTopup(data)
          this.$bvModal.hide('modal-confirm')
        }
      }
      this.selectedTopupId = id
      this.$bvModal.show('modal-confirm')
    },

    /**
     * Handle re-topup action
     */
    async reTopup() {
      this.confirmModalType.retopup.isLoading = true
      this.$bvModal.hide('modal-confirm')
      this.transactionDetail.status = 'processing'
      newAxiosIns.post('komads/api/v1/admin/whitelist_accounts/retry-topup', {
        whitelist_transaction_id: this.selectedTopupId,
      }).then(() => setTimeout(async () => {
        await this.fetchTransactionDetail(this.selectedTopupId)
        if (this.transactionDetail.status === 'failed') {
          this.$toast_error({ title: 'Gagal', message: 'Top Up Ulang Saldo Gagal!' })
          return
        }
        this.$toast.clear()
        this.$toast_success({ title: 'Berhasil', message: 'Top Up Ulang Saldo Berhasil!' })
        this.fetchData()
        this.$store.dispatch('komadsWhitelist/fetchPendingCount')
        this.updateStatusAfterRetopup()
      }, 8000)).catch(() => setTimeout(() => {
        this.$toast.clear()
        this.$toast_error({ title: 'Gagal', message: 'Top Up Ulang Saldo Gagal!' })
      }, 8000)).finally(() => setTimeout(() => {
        this.confirmModalType.retopup.isLoading = false
      }, 8000))
    },
    /**
     * Update status to processing after re-topup
     */
    updateStatusAfterRetopup() {
      this.items.find(item => item.id === this.selectedTopupId).status = 'processing'
    },
    /**
     * Update status to completed
     */
    async updateStatus(status) {
      this.$bvModal.hide('modal-confirm')
      const modalUpdate = this.confirmModalType[this.confirmModalAction]
      modalUpdate.isLoading = true
      const isSuccessMeta = this.transactionDetail.platform_name === 'meta' && status === 'success'
      await newAxiosIns
        .put('komads/api/v1/admin/whitelist_accounts/transactions/update', {
          transaction_id: this.selectedTopupId,
          status,
        })
        .then(() => {
          const opt = { message: 'Status transaksi berhasil diperbarui!' }
          if (isSuccessMeta) {
            opt.title = 'Berhasil'
            opt.message = 'Berhasil update status Selesai!'
          }
          this.$toast_success(opt)
          this.fetchTransactionDetail(this.selectedTopupId)
          this.fetchData()
          this.$store.dispatch('komadsWhitelist/fetchPendingCount')
        })
        .catch(() => {
          const opt = { message: 'Status transaksi gagal diperbarui!' }
          if (isSuccessMeta) {
            opt.title = 'Gagal'
            opt.message = 'Gagal update status Selesai!'
          }
          this.$toast_error(opt)
        })
        .finally(() => {
          modalUpdate.isLoading = false
        })
    },
    async fetchTransactionDetail(id) {
      await newAxiosIns
        .get(`komads/api/v1/admin/whitelist_accounts/transactions/${id}`)
        .then(res => {
          this.transactionDetail = res.data.data
        })
    },

    /**
     * Handle detail drawer
     */
    async handleDetailDrawer(id) {
      this.loading.drawer = true
      this.showDetailDrawer = true

      await this.fetchTransactionDetail(id)
      this.loading.drawer = false
    },
    /**
     * Handle close detail drawer
    */
    handleCloseDetailDrawer() {
      this.showDetailDrawer = false
      setTimeout(() => {
        this.transactionDetail = null
      }, 600)
    },
    /**
     * Handle copy clipboard transaction detail provider
    */
    async handleCopyTransactionDetailProvider() {
      const { status, whitelist_account_name: whitelistAccountName, platform_name: platformName } = this.transactionDetail ?? {}
      const provider = this.transactionDetail?.disbursement_provider ?? {}

      const lines = [
        `Nama Akun WL: ${whitelistAccountName ?? '-'}`,
        `Nominal Top Up: ${IDR(provider.amount_topup ?? 0)}`,
        `Top Up Fee (${provider.fee_topup ?? 0}%): ${IDR(provider.provider_fee ?? 0)}`,
      ]
      if (['failed', 'transferred', 'success'].includes(status) && platformName === 'google') {
        lines.push(`3 Digit Terakhir (Kode Unik): ${provider.unique_code ?? '-'}`)
      }
      lines.push(`Total Dibayarkan: ${IDR(provider.amount_total ?? 0)}`)

      await navigator.clipboard.writeText(lines.join('\n'))
      this.$toast_success({ title: 'Berhasil', message: 'Berhasil salin data transaksi Provider!' })
    },
    /**
     * Handle Check Status
    */
    async handleCheckStatus() {
      if (this.loading.drawerProviderAction) {
        this.$toast.clear()
        this.$toast_error({ title: 'Terjadi kesalahan', message: 'Pengecekan sedang berlangsung. Mohon tunggu beberapa saat' })
        return
      }
      this.loading.drawerProviderAction = true
      this.$toast.clear()
      this.$toast_success({ title: 'Proses Cek Update', message: 'Mohon tunggu beberapa saat, sistem sedang melakukan pengecekan' })
      newAxiosIns.get(`komads/api/v1/admin/whitelist_accounts/transactions/${this.transactionDetail.id}/provider-disbursement-status`)
        .then(() => setTimeout(() => {
          this.$toast.clear()
          this.$toast_success({ title: 'Berhasil', message: 'Status transaksi berhasil diperbarui!' })
          this.fetchTransactionDetail(this.transactionDetail.id)
          this.fetchData()
        }, 2000))
        .catch(() => setTimeout(() => {
          this.$toast.clear()
          this.$toast_error({ title: 'Gagal', message: 'Status transaksi gagal diperbarui!' })
        }, 2000))
        .finally(() => setTimeout(() => {
          this.loading.drawerProviderAction = false
        }, 2000))
    },
    /**
     * Handle download invoice
    */
    async handleDownloadInvoice() {
      if (this.loading.downloadInvoice) return
      this.$toast.clear()
      try {
        this.loading.downloadInvoice = true
        const { data } = await newAxiosIns.get(`komads/api/v1/admin/whitelist_accounts/transactions/${this.transactionDetail.id}/provider-invoice`)
        this.invoiceData = data.data
        setTimeout(() => {
          this.$refs.downloadInvoice.generate()
          this.$toast_success({ message: 'Berhasil mendownload invoice!' })
          this.loading.downloadInvoice = false
        }, 1000)
      } catch (error) {
        this.$toast_error({ message: 'Gagal mendownload invoice!' })
        this.loading.downloadInvoice = false
      }
    },
    /**
     * Handle topup process
    */
    async handleProcessTopup(data = {}) {
      const { uniqueNumber } = data
      this.loading.drawerProcess = true
      this.$toast.clear()
      this.$toast_success({ title: 'Proses Cek Update', message: 'Mohon tunggu beberapa saat, sistem sedang melakukan pengecekan' })

      const payload = {}
      if (uniqueNumber) payload.unique_code = uniqueNumber

      newAxiosIns.post(`komads/api/v1/admin/whitelist_accounts/transactions/${this.transactionDetail.id}/provider-disbursement`, payload)
        .then(() => setTimeout(() => {
          this.$toast.clear()
          this.$toast_success({ title: 'Berhasil', message: 'Status transaksi berhasil diperbarui!' })
          this.fetchTransactionDetail(this.transactionDetail.id)
          this.fetchData()
        }, 2000)).catch(() => setTimeout(() => {
          this.$toast.clear()
          this.$toast_error({ title: 'Gagal', message: 'Status transaksi gagal diperbarui!' })
        }, 2000)).finally(() => setTimeout(() => {
          this.loading.drawerProcess = false
        }, 2000))
    },
    /**
     * Handle confirm input number modal
    */
    handleConfirmInputNumber() {
      if (this.loading.drawerProcess) {
        this.$toast.clear()
        this.$toast_error({ title: 'Terjadi Kesalahan', message: 'Pengecekan sedang berlangsung. Mohon tunggu beberapa saat' })
        return
      }
      this.$bvModal.show('modal-unique-number')
    },

    /**
     * Download Excel file
     */
    async downloadExcel() {
      this.loading.download = true

      const startDate = this.dateRange.startDate
        ? YEAR_MONTH_DAY(this.dateRange.startDate)
        : null

      const endDate = this.dateRange.endDate
        ? YEAR_MONTH_DAY(this.dateRange.endDate)
        : null

      const params = {
        status: this.statusFilter,
        start_date: startDate,
        end_date: endDate,
        platform_name: this.platformFilter,
      }

      try {
        const response = await newAxiosIns.get(
          'komads/api/v1/admin/whitelist_transactions/export',
          {
            params,
            responseType: 'blob',
            headers: {
              Accept: 'application/vnd.ms-excel',
            },
          },
        )

        // Generate filename based on filter parameters
        let fileName = 'Rekap Topup Komads WL'

        if (startDate || endDate || this.statusFilter) {
          const datePart = startDate && endDate ? ` - ${startDate} - ${endDate}` : ''
          const statusPart = this.statusFilter ? ` - ${this.statusFilter}` : ''
          fileName = `Rekap Top Up Komads WL${datePart}${statusPart}`
        }

        fileName += '.xlsx'

        downloadFileFromBlob(response.data, fileName)

        this.$toast_success({ message: 'File berhasil didownload' })
      } catch (error) {
        this.$toast_error({ message: 'Gagal mendownload file' })
      } finally {
        this.loading.download = false
      }
    },

    platformIcon(platform) {
      const icon = {
        meta: 'https://storage.googleapis.com/komerce/komads-meta/meta.svg',
        google: 'https://storage.googleapis.com/komerce/komads-meta/google.svg',
        tiktok: 'https://storage.googleapis.com/komerce/komads-meta/tiktok.svg',
      }
      return icon[platform] || icon.meta
    },
  },
}
</script>

<style scoped>
.scrolled-table {
  height: calc(100vh - 250px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
  will-change: transform;
  transform: translateZ(0);
  backface-visibility: hidden;
}

.scrolled-table .table {
  position: relative;
  border-collapse: separate;
  width: 100%;
  table-layout: fixed;
  margin-bottom: 0;
}

/* Memastikan header tabel tetap terlihat dengan baik */
.scrolled-table .table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
}

/* Memastikan baris tabel memiliki tinggi yang cukup */
.scrolled-table .table tbody tr {
  min-height: 50px;
}
</style>
